// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"SocialMediaFields_fieldWrapper__oua9v","icon":"SocialMediaFields_icon__L3VHP"};